import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SecretPage() {
  const [content, setContent] = useState("");
  const [songUrl, setSongUrl] = useState("/admiration.mp3");
  const [bgImage, setBgImage] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    // Set page title
    document.title = "holly";
    
    // Fetch secret page content
    const fetchContent = async () => {
      try {
        const res = await fetch(`${API}/secret`);
        if (res.ok) {
          const data = await res.json();
          setContent(data.content || "");
          setSongUrl(data.song_url || "/admiration.mp3");
          setBgImage(data.bg_image || "");
        }
      } catch (e) {
        console.error("Error fetching secret content:", e);
      }
    };
    
    fetchContent();

    // Cleanup on unmount - stop the music
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  // Play music when songUrl is loaded
  useEffect(() => {
    if (audioRef.current && songUrl) {
      audioRef.current.volume = 0.5;
      audioRef.current.play().catch(e => {
        // Autoplay might be blocked, that's okay
        console.log("Autoplay blocked, user interaction required");
      });
    }
  }, [songUrl]);

  // Build background style
  const bgStyle = bgImage 
    ? { backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }
    : { backgroundColor: '#000000' };

  return (
    <div className="secret-page" style={bgStyle}>
      {/* Hidden audio player */}
      <audio
        ref={audioRef}
        src={songUrl.startsWith('http') ? songUrl : songUrl}
        loop
        autoPlay
      />

      {/* The paper */}
      <div className="secret-paper">
        <div className="secret-content">
          {content.split('\n').map((line, i) => (
            <p key={i}>{line || '\u00A0'}</p>
          ))}
        </div>
      </div>

      {/* Back button */}
      <div className="secret-footer">
        <Link to="/" className="secret-back">
          &laquo; back to home
        </Link>
      </div>

      <style>{`
        .secret-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
        }

        .secret-paper {
          background: #ffffff;
          max-width: 700px;
          width: 100%;
          min-height: 500px;
          padding: 60px 50px;
          box-shadow: 0 4px 20px rgba(255,255,255,0.1);
        }

        .secret-content {
          font-family: 'Brush Script MT', 'Segoe Script', 'Bradley Hand', cursive;
          font-size: 24px;
          line-height: 1.8;
          color: #1a1a1a;
          white-space: pre-wrap;
        }

        .secret-content p {
          margin: 0;
          min-height: 1.8em;
        }

        .secret-footer {
          margin-top: 30px;
          text-align: center;
        }

        .secret-back {
          color: #444;
          text-decoration: none;
          font-family: 'Courier New', monospace;
          font-size: 12px;
          transition: color 0.3s;
        }

        .secret-back:hover {
          color: #888;
        }
      `}</style>
    </div>
  );
}
